import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ClipboardList, X, ArrowRight } from "lucide-react";

const FooterQAWidget = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <motion.button
        initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1 }}
        onClick={() => setOpen(true)}
        className="fixed bottom-24 right-6 z-40 w-12 h-12 rounded-full bg-card border border-sovereign-gold/40 text-sovereign-gold flex items-center justify-center shadow-lg hover:bg-sovereign-gold/10 transition-colors"
        title="Take the survey"
      >
        <ClipboardList className="w-5 h-5" />
      </motion.button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            className="fixed bottom-24 right-6 z-40 w-[320px] bg-card border border-border rounded-2xl shadow-2xl overflow-hidden"
          >
            <div className="p-4 border-b border-border flex items-center justify-between">
              <div>
                <h3 className="text-sm font-bold text-foreground">Shape The Floor</h3>
                <p className="text-[11px] text-muted-foreground">100+ questions · voice · translate</p>
              </div>
              <button onClick={() => setOpen(false)} className="w-7 h-7 rounded-full hover:bg-secondary flex items-center justify-center">
                <X className="w-4 h-4 text-muted-foreground" />
              </button>
            </div>
            <div className="p-4 space-y-3">
              <p className="text-xs text-foreground leading-relaxed">
                Tell us about Smart Chat, VoiceKey, Live Shopping, AI tools and more. Speak, listen, or translate every question.
              </p>
              <Link
                to="/survey"
                onClick={() => setOpen(false)}
                className="flex items-center justify-between w-full bg-sovereign-gold text-background rounded-full px-4 py-2 text-xs font-bold hover:bg-sovereign-gold/90 transition-colors"
              >
                Open Q&A Survey
                <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FooterQAWidget;
